/// <reference path="../../libs/focus-trap.js" />
/// <reference path="../../framework/local-storage.js" />
/*
 * PDP component that manages the interactions of the recently viewed products
 */
(function ($) {
    $(function () {
        var STORAGE_KEY = 'RecentlyViewed',
            MAX_PRODUCTS_TO_SHOW = 6,
            selectors = {
                breadcrumbsContainer: '#pdp-breadcrumbs',
                thumbContainer: '#breadcrumb-recent-container',
                miniContainer: '#breadcrumb-recent-mini-container',
                miniList: '#recent-minis',
                container: '#recently-viewed-container'
            },
            recentlyViewedProductPages = evo.storage.getItem(STORAGE_KEY) || [],
            $container = $(selectors.container),
            productPageId = $container.attr('data-product-page-id');

        //add the current page id to storage and remove any duplicates
        recentlyViewedProductPages.unshift(productPageId);
        for (var i = 1; i < recentlyViewedProductPages.length; i++) {
            if (recentlyViewedProductPages[i] === productPageId) {
                recentlyViewedProductPages.splice(i, 1);
                break;
            }
        }
        //ensure the list of ids doesn't get too big
        recentlyViewedProductPages.length = Math.min(recentlyViewedProductPages.length, MAX_PRODUCTS_TO_SHOW);
        evo.storage.setItem(STORAGE_KEY, recentlyViewedProductPages);

        var productPagesToShow = recentlyViewedProductPages.slice(1, recentlyViewedProductPages.length);
        if (!productPagesToShow.length) {
            return;
        }

        //build a focus trap that will be used to trap the browser focus
        //inside the recently viewed "modal" for optimal accessiblity
        var trap = focusTrap(selectors.breadcrumbsContainer, {
            initialFocus: selectors.container + ' a'
        });

        $.ajax({
            cache: false,
            data: $.param({ ProductPageIds: productPagesToShow }, true),
            method: 'GET',
            url: $container.attr('data-load-url')
        })
            .done(function (response) {
                $container.html(response);

                var minis = $(selectors.thumbContainer).find('.js-product-thumb-image').map(function () {
                    var $this = $(this),
                        imageUrl = $this.attr('src');
                    return $('<img class="breadcrumb-recent-mini" />').attr('src', imageUrl).attr('alt', '');
                }).get();

                //setup the open/close click event, and show the container
                if (minis.length) {
                    $(selectors.miniList).append(minis);
                    $(selectors.miniContainer).on('click', function (e) {
                        $(this).add(selectors.thumbContainer);
                        $(selectors.container).slideToggle(300);

                        var $miniContainer = $(selectors.miniContainer);
                        if ($miniContainer.is('.active')) {
                            $miniContainer.removeClass('active');
                            trap.deactivate();
                        } else {
                            $miniContainer.addClass('active');
                            trap.activate();
                        }

                        //push the product impressions to the Google dataLayer.
                        if (typeof recentlyViewedDataLayerImpressions !== "undefined" && recentlyViewedDataLayerImpressions.length) {
                            window.dataLayerManager.pushImpressions(recentlyViewedDataLayerImpressions, 'Recently Viewed Products', true);
                        }

                        return false;
                    }).css('visibility', 'visible');
                }
            })
            .fail(function () {
                console.warn('There was an error loading the recently viewed component');
            });
    });
})(jQuery);